import React from 'react';

export type CardVariant = 'default' | 'info' | 'warning' | 'fantasy' | 'metric';

interface CardProps {
  title: string;
  subtitle?: string;
  emoji?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  variant?: CardVariant;
}

const variantStyles: Record<CardVariant, string> = {
  default: 'bg-white border border-gray-200',
  info: 'bg-blue-50 border border-blue-200',
  warning: 'bg-yellow-50 border border-yellow-300',
  fantasy: 'bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50 border border-purple-200',
  metric: 'bg-gradient-to-br from-indigo-50 via-blue-50 to-green-50 border border-indigo-200',
};

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  emoji,
  icon,
  children,
  className = '',
  variant = 'default',
}) => (
  <div
    className={`rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300 p-6 ${variantStyles[variant]} ${className}`}
    style={{ minHeight: 0 }}
  >
    <div className="flex items-start gap-4">
      {emoji && <span className="text-3xl select-none" aria-hidden>{emoji}</span>}
      {icon && <span className="text-2xl select-none" aria-hidden>{icon}</span>}
      <div className="flex-1">
        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">{title}</h3>
        {subtitle && <div className="text-sm text-gray-500 mt-1 mb-2">{subtitle}</div>}
        <div className="mt-2 text-gray-700">{children}</div>
      </div>
    </div>
  </div>
);

export default Card;
